import { Subscription } from 'rxjs';
import { SuccessComponent } from './../modals/success/success.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GetService } from 'src/app/Services/get.service';
import { PostService } from 'src/app/Services/post.service';
import { contentLists } from '../contentForms';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ErrorsComponent } from '../modals/errors/errors.component';
import { DatePipe } from '@angular/common';
import { OrderNumberService } from 'src/app/Services/order-number.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss'],
})
export class AddComponent implements OnInit, OnDestroy {
  contentTypeData: any;
  type: string;
  id: string;
  imageSrc = new Map();
  imageSizeError = new Map();
  public mainForm: FormGroup;
  backendErrors = new Array();
  fieldsCtrls = {};
  record;
  getRecordLink: string;
  postAddLink: string;
  lang: string = 'en';
  formData: FormData;
  slelectedBtn;
  hidearbicMedia: boolean = false;
  hidearabicIcon:boolean = false;
  HidearabicDark:boolean = false;
  hidearabicIMage:boolean = false;
  imageUrl;
  chars;
  newChars=[];
  btnTypes = [{ value: 'none', viewValue: 'None' },
  { value: 'internal_link', viewValue: 'Internal Link' },
  { value: 'external_link', viewValue: 'External Link' },
  { value: 'whatsapp', viewValue: 'Whatsapp' },
  { value: 'phone', viewValue: 'Phone' },

];
  category_id;
  media_category_id;
  media_id;
  cali_unit_id;
  baymount_unit_id;
  section_id;
  offers_section_id;
  routerList;
  backLink;
  modules = {
    formula: true,
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction

      [{ 'size': [false] }],  // custom dropdown
      [{ 'header': [false] }],

      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'font': [false] }],
      [{ 'align': [] }],

      ['clean'],                                         // remove formatting button

      ['link']                         // link and image, video
    ]

  };
  addSubscriptions = new Subscription();
  constructor(
    private get: GetService,
    private route: ActivatedRoute,
    private router: Router,
    private post: PostService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private datepipe: DatePipe, 
    private orderService: OrderNumberService,
    public _domSanitizer: DomSanitizer
  ) {
    this.type = route.snapshot.paramMap.get('type');


    this.contentTypeData = contentLists[this.type];
    this.getRecordLink = contentLists[this.type].getRecordLink;
    this.postAddLink = contentLists[this.type].postAddLink;
    this.formData = new FormData();
    this.createForm(this.contentTypeData.add_form.english);

    if (this.contentTypeData.hasCommon) {
      this.createForm(this.contentTypeData.add_form.common);
    }
    if (this.contentTypeData.hasHidden) {
      this.createForm(this.contentTypeData.add_form.hidden);
    }
    if (this.contentTypeData.hasArabic) {
      this.createForm(this.contentTypeData.add_form.arabic);
    }

    this.mainForm = new FormGroup(this.fieldsCtrls);

    if (this.category_id) {
      this.mainForm.patchValue({
        category_id: this.category_id,
      });
    }
    if (this.media_category_id) {
      this.mainForm.patchValue({
        media_category_id: this.media_category_id,
      });
    }
    if (this.media_id) {
      this.mainForm.patchValue({
        media_id: this.media_id,
      });
    }
    if (this.cali_unit_id) {
      this.mainForm.patchValue({
        cali_unit_id: this.cali_unit_id,
      });
    }
    if(this.baymount_unit_id){
      this.mainForm.patchValue({
        cali_unit_id: this.cali_unit_id,
      });
    }
    if (this.offers_section_id) {
      this.mainForm.patchValue({
        offers_section_id: this.offers_section_id,
      });
    }
    if (this.section_id) {
      this.mainForm.patchValue({
        section_id: this.section_id,
      });
    }
    this.imageUrl = environment.imgUrl;

    setTimeout(() => {
      this.spinner.hide();
    }, 800);
  }
  createForm(fields) {
    let is_required;
    for (let f of fields) {
      if(f.required){
        is_required=Validators.required;
      }else{
        is_required=null
      }
      // console.log('  f.valued', f.value);
      // if (f.type != 'checkbox') {
      if (f.name == 'category_id' ) {
        this.category_id = Number(
          this.route.snapshot.paramMap.get('category_id')
        );


        f.value = this.category_id;
      }
      if (f.name == 'section_id' ) {
        this.section_id = Number(
          this.route.snapshot.paramMap.get('category_id')
        );


        f.value = this.category_id;
      }
      if (f.name == 'media_category_id'){
        this.media_category_id= Number(
          this.route.snapshot.paramMap.get('category_id')
        );


        f.value = this.media_category_id;
      }
      if (f.name == 'cali_unit_id'){
        this.cali_unit_id= Number(
          this.route.snapshot.paramMap.get('category_id')
        );
        f.value = this.cali_unit_id;
        // console.log('ana media id', this.media_id);

      }
      if (f.name == 'baymount_unit_id'){
        this.baymount_unit_id= Number(
          this.route.snapshot.paramMap.get('category_id')
        );
        f.value = this.baymount_unit_id;
        // console.log('ana media id', this.media_id);

      }
      if (f.name == 'offers_section_id'){
        this.offers_section_id= Number(
          this.route.snapshot.paramMap.get('category_id')
        );
        f.value = this.media_id;
        // console.log('ana media id', this.media_id);

      }
     
      if (f.name == 'media_id'){
        this.media_id= Number(
          this.route.snapshot.paramMap.get('category_id')
        );
        f.value = this.media_id;
        // console.log('ana media id', this.media_id);

      }
      // console.log('ana cat id',this.category_id);
      this.fieldsCtrls[f.name] = new FormControl(f.value,  is_required);
      if (f.type == 'file' || f.type == 'doc') {
        this.imageSrc[f.name] = f.value;
        this.imageSizeError[f.name] = false;
      }
      if (f.name =='published_at'){

       f.value =  this.datepipe.transform(f.value, 'YYYY-MM-DD')
      }
      this.formData.set(f.name, f.value);

      // } else {
      //   let opts = {};
      //   for (let opt of f.options) {

      //     opts[f.name] = new FormControl(opt.value);
      //   }
      //   this.fieldsCtrls[f.name] = new FormGroup(opts);
      // }
    }
  }
  onClickImg() {}
  ngOnInit(): void {
    this.spinner.show();
    console.log(this.orderService.order_number);
    
    this.backLink=this.contentTypeData.backLink;
    this.routerList=this.contentTypeData.routerList;

    // this.getRecordData();
    if (this.route.snapshot.paramMap.get('category_id')) {
      this.backLink=this.contentTypeData.backLink +
        this.route.snapshot.paramMap.get('category_id');
      this.routerList=this.contentTypeData.routerList +
        this.route.snapshot.paramMap.get('category_id');
    }else if(this.mainForm?.get('section_id')?.value){
      this.backLink=this.contentTypeData.backLink +this.mainForm.get('section_id').value;
      this.routerList=this.contentTypeData.routerList +this.mainForm.get('section_id').value;
    }else if(this.mainForm?.get('offers_section_id')?.value){
      this.backLink=this.contentTypeData.backLink +this.mainForm.get('offers_section_id').value;
      this.routerList=this.contentTypeData.routerList +this.mainForm.get('offers_section_id').value;
    }
    else{
      this.backLink=this.contentTypeData.backLink;
      this.routerList=this.contentTypeData.routerList;
    }
    console.log(this.backLink);
    
this.mainForm.patchValue({
  order:this.orderService.order_number
})
  }
  textChange(e, content){
    console.log(e,content);
   this.newChars = (content.replace( /(<([^>]+)>)/ig, '')).length;
  }
  submit() {
    console.log(this.mainForm.value);
    
    this.mainForm.markAllAsTouched();
    if (!this.mainForm.valid) {
      this.spinner.hide();
      const dialogref = this.dialog.open(ErrorsComponent, {data: 'Please Make Sure To Fill Both English & Arabic Fields'})
      dialogref.afterClosed().subscribe((reply)=>{
       if(reply){
            this.dialog.closeAll();
       }
      })
      return;
    }

    this.spinner.show();
    let fields = [];

    fields = fields.concat(this.contentTypeData.add_form.english);
    if (this.contentTypeData.hasCommon == true) {
      fields = fields.concat(this.contentTypeData.add_form.common);
    }
    if (this.contentTypeData.hasHidden == true) {
      fields = fields.concat(this.contentTypeData.add_form.hidden);
    }
    if (this.contentTypeData.hasArabic == true) {
      fields = fields.concat(this.contentTypeData.add_form.arabic);
    }

    var value;
    for (let f of fields) {


      switch (f.type) {
        case 'file':
          break;
        case 'checkbox':
          value = Number(this.mainForm.get(f.name).value);
          this.formData.set(f.name, value);
        break;
          case'doc':
          break;
          case 'date':
            value = this.mainForm.get(f.name).value;
            this.datepipe.transform(value, 'yyyy-MM-dd');
            this.formData.set(f.name,  this.datepipe.transform(value, 'yyyy-MM-dd'));
          break;
        default:
          value = this.mainForm.get(f.name).value;
          this.formData.set(f.name, value);
          break;
      }
    }
    this.spinner.show();
   this.addSubscriptions= this.post.submit(this.postAddLink, this.formData).subscribe(
      (res) => {

        // this.mainForm.patchValue(res.response.data);
        setTimeout(() => {
          this.spinner.hide();
          this.dialog.open(SuccessComponent);
        }, 800);
        setTimeout(() => {
          this.dialog.closeAll();
            this.router.navigate([this.routerList]);

        }, 1500);
      },

      (error) => {
        this.spinner.hide();
        this.backendErrors = error.error.errors;
        for(let errElement in this.backendErrors){
          for (let errItem = 0; errItem < this.backendErrors[errElement].length; errItem++) {
            const item = this.backendErrors[errElement][errItem];
          const dialogref = this.dialog.open(ErrorsComponent, {data: item})
          dialogref.afterClosed().subscribe((reply)=>{
           if(reply){
                this.dialog.closeAll();
           }
          })
        }
        }

      }
    );
  }

  openDialog() {
    this.dialog.open(SuccessComponent);
  }
  upload(event, fieldName) {
    // this.progress = 1;
    let file;
    let fileSize;
    const files: File = event.target.files;
    file = files[0];
    fileSize = Math.round(file.size / 1024);

    let vaildSize = fileSize <= 9216;

    const reader = new FileReader();

    if (event.target.files.length && vaildSize) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imageSrc[fieldName] = reader.result as string;
        var obj = {};
        obj[fieldName] = event.target.files[0];
        this.formData.append(fieldName, event.target.files[0]);
      };
    } else {
      this.imageSizeError[fieldName] = true;
    }
  }

  triggerClick(fieldID) {
    document.getElementById(fieldID).click();
  }
  onCheckboxChange(fieldName, value) {
    if(value == 0){
      document.getElementById(fieldName+'-container').classList.add('d-none');
    }else{
      document.getElementById(fieldName+'-container').classList.remove('d-none');
    }
  }
  ngOnDestroy(): void {

    this.addSubscriptions.unsubscribe();

  }
}
